import { render, staticRenderFns } from "./SystemCustomNotificationsListItem.vue?vue&type=template&id=70ef3a06"
import script from "./SystemCustomNotificationsListItem.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports